import React from 'react'

import { Card } from '../../card'
import Strong from '../../text/Strong'
import Text from '../../text/Base'

import { ToastProps } from './types'
import styles from './index.module.scss'

/**
 * Template component for the visual display of the actual toast notification.
 */
const Toast: React.FC<ToastProps> = ({ message, title, severity }) => (
  <>
    <li id="card-wrapper" className={styles.ToastWrapper}>
      <Card
        className={[styles.ToastCard, styles[`ToastCard_${severity}`]].join(
          ' ',
        )}
      >
        {title && (
          <>
            <Strong>{title}</Strong>
            <br />
          </>
        )}
        <Text>{message}</Text>
      </Card>
    </li>
  </>
)

export { Toast }
